import { Routes, Route, Navigate } from "react-router-dom";
import { PageNames } from "../types/AppTypes";
import PageError403 from "../screens/Errors/PageError403/PageError403";
import PageError401 from "../screens/Errors/PageError401/PageError401";
import PageMaintenance from "../screens/Errors/PageMaintenance/PageMaintenance";
import PageErrorNotDesktop from "../screens/Errors/PageErrorNotDesktop/PageErrorNotDesktop";

type ErrorRouterProps = {
  error: "forbidden" | "unauthorized" | "maintenance" | "notDesktop";
  logout: () => void;
  onRetry: () => void;
};

export const ErrorRouter = ({ error, logout, onRetry }: ErrorRouterProps) => {
  const getDefaultRoute = () => {
    switch (error) {
      case "forbidden":
        return PageNames.PAGE_ERROR_403;
      case "unauthorized":
        return PageNames.PAGE_ERROR_401;
      case "notDesktop":
        return PageNames.PAGE_ERROR_NOT_DESKTOP;
      default:
        return PageNames.PAGE_MAINTENANCE;
    }
  };

  return (
    <Routes>
      <Route path="/" element={<Navigate to={getDefaultRoute()} replace />} />
      <Route
        path={PageNames.PAGE_ERROR_403}
        element={<PageError403 logout={logout} />}
      />
      <Route
        path={PageNames.PAGE_MAINTENANCE}
        element={<PageMaintenance onRetry={onRetry} />}
      />
      <Route path={PageNames.PAGE_ERROR_401} element={<PageError401 />} />
      <Route
        path={PageNames.PAGE_ERROR_NOT_DESKTOP}
        element={<PageErrorNotDesktop />}
      />
      <Route path="*" element={<Navigate to={"/"} replace />} />
    </Routes>
  );
};
